import { onEvent } from "./_dom";

export function init(context) {
	onEvent(context, ".v3-searchform", "submit", (event, form) => {
		const input = form.querySelector('.v3-searchform__input');
		const inputValue = input.value;
		if (inputValue === '') {
			input.focus();
			event.preventDefault();
		}
	});
	// Safari does not set focus on buttons, thus on MD size,
	// when the only button is visible, input does not show up due to form:focus-within.
	const searchButton = context.querySelector('.v3-searchform__button');
	if (searchButton) {
		// prevent focus on mousedown
		searchButton.onmousedown = e => e.preventDefault();
		// if input is collapsed, let focus-within show it, but prevent submit.
		searchButton.onclick = e => {
			const input = e.target.parentElement.querySelector('.v3-searchform__input');
			if (input.offsetWidth === 0) {
				e.preventDefault();
				e.target.focus();
				setTimeout(() => input.focus());
			}
		};
	}
}
